"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueMetaModel = void 0;
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const MetaModel_1 = __importDefault(require("../MetaModel"));
exports.IssueMetaModel = new MetaModel_1.default({
    name: () => lib_i18n_1.default.t('issues'),
    queryName: 'issuesElastic',
    aggQueryName: 'issuesAggregation',
    alwaysGetGqlFields: 'status',
    canExportPDF: true,
    canExportData: true,
    canSaveReports: true,
    filterables: [
        QueryFieldKey_1.default.KEYWORD,
        QueryFieldKey_1.default.PLACE,
        QueryFieldKey_1.default.OPDEFINITION,
        QueryFieldKey_1.default.ISSUE_STATUS,
        QueryFieldKey_1.default.ISSUE_DUESTATUS,
        QueryFieldKey_1.default.ISSUE_RESOLUTIONTIME,
        QueryFieldKey_1.default.ISSUE_FLAG,
        QueryFieldKey_1.default.ISSUE_TYPE,
        QueryFieldKey_1.default.ISSUE_HASOP,
        QueryFieldKey_1.default.ISSUE_CREATEDBY,
        QueryFieldKey_1.default.ISSUE_ASSIGNEDTO,
        QueryFieldKey_1.default.ISSUE_OCCURRENCEDATE,
        QueryFieldKey_1.default.ISSUE_DEADLINEDATE,
        QueryFieldKey_1.default.ISSUE_CLOSEDDATE,
        QueryFieldKey_1.default.ASSET,
    ],
    groupables: [
        QueryFieldKey_1.default.ISSUE_STATUS,
        QueryFieldKey_1.default.ISSUE_DUESTATUS,
        QueryFieldKey_1.default.ISSUE_FLAG,
        QueryFieldKey_1.default.ISSUE_TYPE,
        QueryFieldKey_1.default.ISSUE_RESOLUTIONTIME,
        QueryFieldKey_1.default.PLACE,
        QueryFieldKey_1.default.OPDEFINITION,
        QueryFieldKey_1.default.ASSET,
    ],
    fields: [
        ViewFieldKey_1.default.ID,
        ViewFieldKey_1.default.TITLE,
        ViewFieldKey_1.default.ISSUE_OCCURRENCE,
        ViewFieldKey_1.default.UPDATEDDATE,
        ViewFieldKey_1.default.ISSUE_DEADLINEDATE,
        ViewFieldKey_1.default.ISSUE_CLOSEDDATE,
        ViewFieldKey_1.default.ISSUE_CLOSEDBY,
        ViewFieldKey_1.default.PLACE,
        ViewFieldKey_1.default.ISSUE_CREATEDBY,
        ViewFieldKey_1.default.ISSUE_RESOLUTION_TIME,
        ViewFieldKey_1.default.ISSUE_STATUS,
        ViewFieldKey_1.default.ISSUE_FLAG,
        ViewFieldKey_1.default.ISSUE_ASSIGNEDTO,
        ViewFieldKey_1.default.ISSUE_TYPE,
        ViewFieldKey_1.default.ISSUE_DUESTATUS,
        ViewFieldKey_1.default.ISSUE_OP,
        ViewFieldKey_1.default.ISSUE_ASSET,
        ViewFieldKey_1.default.ISSUE_LASTCOMMENT,
        ViewFieldKey_1.default.ISSUE_CAUSES,
        ViewFieldKey_1.default.ISSUE_CORRECTIVEACTIONS,
        ViewFieldKey_1.default.ISSUE_PREVENTATIVEACTIONS,
    ],
});
exports.default = exports.IssueMetaModel;
